import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  id: "slider-parent-container",
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_2 = {
  id: "slider-button-previous",
  class: "dates-slider-container__button border-0 bg-white"
}
const _hoisted_3 = {
  id: "dates-slider-container",
  class: "d-flex align-items-center",
  ref: "datesSliderContainer"
}
const _hoisted_4 = ["data-slide-item", "disabled"]
const _hoisted_5 = {
  id: "slider-button-next",
  class: "dates-slider-container__button border-0 bg-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      _createElementVNode("img", {
        src: "/assets/images/previous-arrow.svg",
        alt: "previous-arrow",
        srcset: "",
        "data-button-action": "previous",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSlidePrevious && _ctx.handleSlidePrevious(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "dates-slider-container__inner d-inline-flex",
        ref: "sliderItems",
        style: _normalizeStyle([{transform: `translate(${_ctx.currentTransform}px, 0)`}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDates, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.id.split('T')[0],
            class: _normalizeClass(["dates-slider-container__inner__item mx-2 d-flex flex-column", { 'dates-slider-container__inner__item__active': _ctx.isSelectedDate.id === item.id,
                'dates-slider-container__inner__item__disabled': _ctx.isDisabledDate(item.id)
              }]),
            "data-slide-item": item.id,
            disabled: _ctx.isDisabledDate(item.id),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.select && _ctx.select(...args)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["dates-slider-container__inner__item__title", {'dates-slider-container__inner__item__active__title': _ctx.isSelectedDate.id === item.id}])
            }, _toDisplayString(_ctx.$t(item.weekday)), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["dates-slider-container__inner__item__content", {'dates-slider-container__inner__item__active__content': _ctx.isSelectedDate.id === item.id}])
            }, _toDisplayString(_ctx.$t(item.month + '_whose')) + " " + _toDisplayString(item.monthDay), 3)
          ], 10, _hoisted_4))
        }), 128))
      ], 4)
    ], 512),
    _createElementVNode("button", _hoisted_5, [
      _createElementVNode("img", {
        src: "/assets/images/next-arrow.svg",
        alt: "next-arrow",
        srcset: "",
        "data-button-action": "next",
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSlideNext && _ctx.handleSlideNext(...args)))
      })
    ])
  ]))
}